import React from 'react';
import { Heading } from '@beef/legacy-ui-kit';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

import { formatPrice, formatPriceExtended } from 'utils/formatting';

import InlineSet from '../InlineSet';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

/** Component displays price value, with possible discount */
export default function Price({
  children,
  className,
  doReserveSpace,
  level,
  oldValue,
  priceComment,
  value,
}) {
  return (
    <div className={cx('component', className)}>
      {oldValue && value < oldValue ?
        <Heading className={cx('oldValue')} level={parseInt(level + 2, 10)} tagName="div">
          {`${formatPrice(oldValue)} ₽`}
        </Heading>
      : doReserveSpace && (
          <Heading level={parseInt(level + 2, 10)} tagName="div">
            &nbsp;
          </Heading>
        )
      }
      <Heading
        className={cx({ level3_5: level === 3.5 }, priceComment && 'withComment')}
        level={parseInt(level, 10)}
        tagName="div"
      >
        <InlineSet spacingSize={(level <= 2 && 'large') || null}>
          <>{`${formatPriceExtended(value)}`}</>
          {children}
        </InlineSet>
        {priceComment && <span className={cx('comment')}>{priceComment}</span>}
      </Heading>
    </div>
  );
}

Price.defaultProps = {
  level: 1,
};

Price.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  doReserveSpace: PropTypes.bool, // if set to true, it will reserve space for old price value even if its missing
  level: PropTypes.oneOf([1, 2, 3, 3.5]), // along either 1,2,3 has extra hard-coded size 3.5
  oldValue: PropTypes.number, // value in rubbles before applying discount
  priceComment: PropTypes.string,
  value: PropTypes.number, // value in rubles
};
